import { Panels } from '../Consts';
import { useAppContext } from '../../AppContext';
import React, { useEffect, useRef, useState } from 'react';
import { DISTRIBUTION_TYPE_EQUALLY, DISTRIBUTION_TYPE_PARTS, DISTRIBUTION_TYPE_VALUE, valueFormatterDistributions } from './components/DistributionTypeTabsComponent';
import { getResponseFromError } from '../../helpers/helpers';
import { Button, FormItem, FormLayoutGroup, Panel, PullToRefresh } from '@vkontakte/vkui';
import { NameInputComponent } from './components/NameInputComponent';
import { CommentInputComponent } from './components/CommentInputComponent';
import { AmountInputComponent } from './components/AmountInputComponent';
import { DateInputComponent } from './components/DateInputComponent';
import { MembersInputComponent } from './components/MembersInputComponent';
import { UserSelectComponent } from './components/UserSelectComponent';
import { DistributionTypeTabsComponent } from './components/DistributionTypeTabsComponent';
import { AddJoinedMembersComponent } from './components/AddJoinedMembersComponent';
import { clearCache as eventInfoCacheClear } from '../Events/ShowEventPanel';
import { ErrorLoadComponent } from '../components/ErrorLoadComponent';
import { MAX_PAYMENT_AMOUNT, MIN_AMOUNT } from '../../Consts';
import { ImageUploadComponent } from './components/ImageUploadComponent';
import { SelectImagesDeleteComponent } from '../components/SelectImagesDeleteComponent';
import { getRouteEventInfo } from '../../route';
import { PlatformPanelHeader } from '../components/PlatformPanelHeader';

const CURRENT_PANEL = Panels.EDIT_PAYMENT_PANEL;

const EditPaymentPanel = () => {
  const context = useAppContext();
  const params = context.router.getParams();

  const [users, setUsers] = useState([])
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState('');
  const [price, setPrice] = useState('');
  const [priceError, setPriceError] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [dateError, setDateError] = useState('');
  const [images, setImages] = useState([]);
  const [imagesError, setImagesError] = useState('');
  const [creatorId, setCreatorId] = useState(0);
  const [creatorError, setCreatorError] = useState('');
  const [members, setMembers] = useState([]);
  const [membersError, setMembersError] = useState('');

  const [distributionType, setDistributionType] = useState(DISTRIBUTION_TYPE_EQUALLY);
  const [distributionTypeError, setDistributionTypeError] = useState('');

  const [equallyDistributions, setEquallyDistributions] = useState({});
  const [equallyDistributionsErrors, setEquallyDistributionsErrors] = useState({});
  const [partDistributions, setPartDistributions] = useState({});
  const [partDistributionsErrors, setPartDistributionsErrors] = useState({});
  const [valueDistributions, setValueDistributions] = useState({});
  const [valueDistributionsErrors, setValueDistributionsErrors] = useState({});
  const [addJoinedMembers, setAddJoinedMembers] = useState(false);
  const [updateToken, setUpdateToken] = useState(null);

  const isFormSavedRef = useRef(false);
  const [sendSave, setSendSave] = useState(false);
  const [errorInit, setErrorInit] = useState(null);

  const fetch = (spinner = true) => {
    if (spinner) {
      context.spinner(true);
    }
    context.init().then(() => {
      Promise.all([
        context.httpClient().getEventV3(params.eventId),
        context.httpClient().getPayment(params.eventId, params.id),
      ])
      .then((results) => {
        const [event, item, itemUsers] = [results[0].data, results[1].data.item, results[1].data.users];
        const allUsers = {};
        itemUsers.forEach((item) => {
          allUsers[item.id] = {
            value: item.id,
            label: item.name,
            img: item.img,
            type: item.type,
          };
        });
        (event.users || []).forEach((item) => {
          allUsers[item.id] = {
            value: item.id,
            label: item.name,
            img: item.img,
            type: item.type,
          };
        });

        setName(item.name);
        setComment(item.comment);
        setPrice(item.amount);
        setDateTime(context.lang().dateFormatToInput(new Date(item.date)));
        setImages(item.images || []);
        setCreatorId(item.creator_id);
        setDistributionType(item.distribution_type);
        setAddJoinedMembers(item.add_joined_members);
        //users - Все пользователи из события
        setUsers(Object.values(allUsers));

        const parts = {};
        const values = {};
        const equally = {};
        //members - все участники затраты
        setMembers(item.members.map((member) => {
          if (member.parts) {
            parts[member.id] = member.parts;
          }
          values[member.id] = member.amount;
          equally[member.id] = member.amount;

          return allUsers[member.id];
        }));

        if (item.distribution_type === DISTRIBUTION_TYPE_EQUALLY) {
          setEquallyDistributions(equally);
        } else if (item.distribution_type === DISTRIBUTION_TYPE_PARTS) {
          setPartDistributions(parts);
        } else if (item.distribution_type === DISTRIBUTION_TYPE_VALUE) {
          setValueDistributions(values);
        }

        setUpdateToken(item.update_token);

        setErrorInit(null);
        context.spinner(false);
      })
      .catch((error) => {
        setErrorInit(error);
        context.spinner(false);
      });
    })
    .catch((error) => {
      setErrorInit(error);
      context.spinner(false);
    })
  }

  useEffect(() => {
    fetch();
  }, []);

  const handleSaveButtonClick = () => {
    if (isFormSavedRef.current) {
      return;
    }

    isFormSavedRef.current = true;
    setSendSave(true);
    context.spinner(true);
    const distributionTypeValue = valueFormatterDistributions(distributionType, members.map(({ value }) => value), partDistributions, valueDistributions);
    context.httpClient().updatePaymentV4(
      params.eventId,
      params.id,
      name,
      comment,
      price,
      dateTime,
      distributionTypeValue,
      creatorId,
      distributionType,
      images.map((img) => img.id),
      addJoinedMembers,
      updateToken
    )
    .then((response) => {
      eventInfoCacheClear(params.eventId, context.cache);
      isFormSavedRef.current = false;
      setSendSave(false);
      context.spinner(false);
      if ((params.openPage || '') === 'events_list') {
        context.router.replace(...getRouteEventInfo(params.eventId));
      } else {
        context.router.backTo(Panels.EVENT_INFO)
          .then(() => {})
          .catch((r) => r.replace(...getRouteEventInfo(params.eventId)))
      }
    })
    .catch((error) => {
      isFormSavedRef.current = false;
      setSendSave(false);
      context.spinner(false);

      const response = getResponseFromError(error);
      if (!response) {
        context.showError(error);
        return;
      }

      setNameError(response.name || '');
      delete response['name'];
      setCommentError(response.comment || '');
      delete response['comment'];
      setPriceError(response.amount || '');
      delete response['amount'];
      setDateError(response.date || '');
      delete response['date'];
      setCreatorError(response.creator || '');
      delete response['creator'];
      setDistributionTypeError(response.distribution_type || '');
      delete response['distribution_type'];
      setMembersError(response.users || '');
      delete response['users'];

      if (response.values) {
        setMembersError(response.values || '');
        delete response['values'];
      }
      if (response.parts) {
        setMembersError(response.parts || '');
        delete response['parts'];
      }

      const valueTypeErrors = {};
      const partsTypeErrors = {};
      const equallyTypeErrors = {};
      const imagesErrors = [];
      Object.keys(response).forEach((key) => {
        const [name, index] = key.split('.', 2);
        switch (name) {
          case 'values':
            valueTypeErrors[index] = response[key] || '';
            delete response[key];
            break;
          case 'parts':
            partsTypeErrors[index] = response[key] || '';
            delete response[key];
            break;
          case 'users':
            equallyTypeErrors[index] = response[key] || '';
            delete response[key];
            break;
          case 'images':
            imagesErrors.push(response[key] || '');
            delete response[key];
            break;
        }
      });
      setEquallyDistributionsErrors(equallyTypeErrors);
      setPartDistributionsErrors(partsTypeErrors);
      setValueDistributionsErrors(valueTypeErrors);
      setImagesError(imagesErrors.join(','));

      if (response.update_token || null) {
        context.showError(null, (response.update_token || []).join(', '));
      } else if (response.message) {
        context.showError(null, response.message);
      } else if (Object.keys(response).length > 0) {
        context.showError(error);
      }
    });
  }

  if (errorInit) {
    return (<ErrorLoadComponent
      error={errorInit}
      onFetch={fetch}
    />)
  }

  return (<Panel id={CURRENT_PANEL}>
    <PlatformPanelHeader
      text={context.lang().getKey(CURRENT_PANEL, 'header')}
    />
    {context.snackbar}
    <form>
      <FormLayoutGroup mode="vertical">
        <PullToRefresh onRefresh={() => fetch(false)}>
          <NameInputComponent
            name={name}
            setName={setName}
            error={nameError}
            setError={setNameError}
            label={context.lang().getKey('app', 'name_input_label')}
            errorTextMinLength={context.lang().getKey('errors', 'name_error_min_length_2_char')}
          />
          <AmountInputComponent
            amount={price}
            setAmount={setPrice}
            min={MIN_AMOUNT}
            max={MAX_PAYMENT_AMOUNT}
            error={priceError}
            setError={setPriceError}
            label={context.lang().getKey('app', 'amount_input_label')}
            errorTextMin={context.lang().getKey('errors', 'amount_error_min')}
            errorTextMax={context.lang().getKey('errors', 'amount_error_max')}
          />
          <DateInputComponent
            defaultDate={context.lang().dateFormatToInput(new Date())}
            dateTime={dateTime}
            setDateTime={setDateTime}
            error={dateError}
            setError={setDateError}
            label={context.lang().getKey('app', 'date_input_label')}
            errorTextMinValue={context.lang().getKey('errors', 'date_error_min')}
            errorTextMaxValue={context.lang().getKey('errors', 'date_error_max')}
          />
          <MembersInputComponent
            error={membersError}
            setError={setMembersError}
            members={users}
            value={members}
            setValue={setMembers}
            label={context.lang().getKey('app', 'members_input_label')}
            placeholder={context.lang().getKey('app', 'members_input_placeholder')}
            allItemsLabel={context.lang().getKey('app', 'all_members_items_label')}
          />
          <UserSelectComponent
            label={context.lang().getKey('app', 'creator_input_label')}
            placeholder={context.lang().getKey('app', 'creator_input_placeholder')}
            error={creatorError}
            setError={setCreatorError}
            members={users}
            value={creatorId}
            setValue={setCreatorId}
          />
          <DistributionTypeTabsComponent
            price={price}
            creator={creatorId}
            members={members}
            distributionType={distributionType}
            setDistributionType={setDistributionType}
            equallyDistributionsValue={equallyDistributions}
            setEquallyDistributionsValue={setEquallyDistributions}
            partDistributionsValue={partDistributions}
            setPartDistributionsValue={setPartDistributions}
            partDistributionsErrors={partDistributionsErrors}
            setPartDistributionsErrors={setPartDistributionsErrors}
            valueDistributionsValue={valueDistributions}
            setValueDistributionsValue={setValueDistributions}
            valueDistributionsErrors={valueDistributionsErrors}
            setValueDistributionsErrors={setValueDistributionsErrors}
            labelTabEqually={context.lang().getKey('app', 'distribution_type_label_equally')}
            labelTabValue={context.lang().getKey('app', 'distribution_type_label_value')}
            labelTabParts={context.lang().getKey('app', 'distribution_type_label_parts')}
            placeholder={context.lang().getKey('app', 'distribution_type_tab_placeholder')}
          />
          <AddJoinedMembersComponent
            label={context.lang().getKey('app', 'add_joined_members_input_label')}
            checked={addJoinedMembers}
            onChange={(event) => setAddJoinedMembers(event.target.checked)}
            disabled={distributionType === DISTRIBUTION_TYPE_VALUE}
          />
          <ImageUploadComponent
            eventId={params.eventId}
            value={images}
            setValue={setImages}
            error={imagesError}
            setError={setImagesError}
            label={context.lang().getKey('app', 'image_input_label')}
            errorTextMaxSize={context.lang().getKey('errors', 'image_error_max_size')}
            errorTextType={context.lang().getKey('errors', 'image_error_type')}
            errorMaxCount={context.lang().getKey('errors', 'image_error_max_count')}
            buttonLabel={context.lang().getKey('app', 'image_button_label__empty')}
            buttonLabelSelect={context.lang().getKey('app', 'image_button_label__selected')}
            maxSize={context.store.maxFileSize}
          />
          <SelectImagesDeleteComponent
            value={images}
            setValue={setImages}
          />
          <CommentInputComponent
            comment={comment}
            setComment={setComment}
            error={commentError}
            setError={setCommentError}
            label={context.lang().getKey('app', 'comment_input_label')}
            errorTextMaxLength={context.lang().getKey('errors', 'comment_error_max_length_255_char')}
          />
        </PullToRefresh>
        <FormItem>
          <Button
            size={'l'}
            stretched
            loading={sendSave}
            disabled={sendSave || !price || price < MIN_AMOUNT || price > MAX_PAYMENT_AMOUNT || name.length < 2}
            onClick={handleSaveButtonClick}
          >
            {context.lang().getKey(CURRENT_PANEL, 'button_save_label')}
          </Button>
        </FormItem>
      </FormLayoutGroup>
    </form>
  </Panel>);
};

export default EditPaymentPanel;
